import React, { Fragment } from "react";
import Head from "next/head";

const ProductMeta = ({ shop, product }) => {
  const meta_tag_name = "facebook-domain-verification";

  return (
    <Head>
      <title>
        {shop?.title
          ? `${shop.title} - ${product?.title} | Powered by Carte`
          : `${product?.title} | Powered by Carte`}
      </title>
      <meta
        name="description"
        content={
          product?.description || "All you need to launch your business online. No coding required."
        }
      />
      <link
        rel="canonical"
        href={`${
          typeof window !== "undefined"
            ? `${window.location.origin}`
            : `https://${shop?.subdomain ? shop.subdomain + "." : ""}carteapp.io`
        }/products/${product && product.product_id ? product.product_id : ""}`}
      />
      <meta
        property="og:type"
        content={
          shop?.title
            ? `${shop.title} - ${product?.title} | Powered by Carte`
            : `${product?.title} | Powered by Carte`
        }
        key="ogtype"
      />
      <meta
        property="og:site_name"
        content={
          shop?.title ? `${shop.title} - ${product?.title} | Powered by Carte` : "Carte Shop"
        }
        key="ogsitename"
      />
      <meta
        property="og:url"
        href={`${
          typeof window !== "undefined"
            ? `${window.location.origin}`
            : `https://${shop?.subdomain ? shop.subdomain + "." : ""}carteapp.io`
        }/products/${product?.product_id || ""}`}
        key="ogurl"
      />
      <meta
        property="og:title"
        content={
          shop?.title
            ? `${shop.title} - ${product?.title} | Powered by Carte`
            : `${product?.title} | Powered by Carte`
        }
        key="ogtitle"
      />
      <meta
        property="og:description"
        content={
          product?.description || "All you need to launch your business online. No coding required."
        }
        key="ogdesc"
      />
      <meta
        property="og:image"
        content={
          product?.images[0]?.image ||
          shop?.logo ||
          shop?.vendor?.company_photo ||
          "https://carte-assets.carteapp.io/fettuccine/logov2.png"
        }
        key="ogimage"
      />
      <meta property="og:price:amount" content={product?.price} key="ogpriceamount" />
      <meta property="og:price:currency" content={`SGD`} key="ogpricecurrency" />
      <meta
        property="product:brand"
        content={`${shop?.title || "Carte Shop"}`}
        key="productbrand"
      />
      <meta
        property="product:availability"
        content={`${
          product && (!product.inventory || product.inventory > 0) ? "in stock" : "out of stock"
        }`}
        key="productavailability"
      />
      <meta property="product:condition" content={`new`} key="productcondition" />
      <meta property="product:price:amount" content={product?.price} key="productpriceamount" />
      <meta property="product:price:currency" content={`SGD`} key="productpricecurrency" />
      <meta
        property="product:retailer_item_id"
        content={product?.product_id}
        key="productretailer_item_id"
      />

      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content={
          shop?.title ? `${shop.title} - ${product?.title} | Powered by Carte` : "Carte Shop"
        }
      />
      <meta
        name="twitter:description"
        content={
          product?.description || "All you need to launch your business online. No coding required."
        }
      />
      <meta
        name="twitter:image"
        content={
          product?.images[0]?.image ||
          shop?.logo ||
          shop?.vendor?.company_photo ||
          "https://carte-assets.carteapp.io/fettuccine/logov2.png"
        }
      />
      {shop?.meta_tag_is_active && (
        <Fragment>
          {/* <meta name={"facebook-domain-verification"} content={shop.meta_tag_content} /> */}
          <script>
            {`!function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${shop?.meta_pixel_id}');
                fbq('track', 'PageView');
                fbq('track', 'ViewContent', { content_type: 'product', content_ids: ['${product?.product_id}'] });`}
          </script>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: "none" }}
              src={`https://www.facebook.com/tr?id=${shop?.meta_pixel_id}&ev=PageView&noscript=1`}
            />
          </noscript>
        </Fragment>
      )}
    </Head>
  );
};

export default ProductMeta;
